
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[projectSlug]",
      function () {
        return require("private-next-pages/[projectSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[projectSlug]"])
      });
    }
  